const inputValidations = (value, type) => {
  switch (type) {
    case "email":
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value);

    case "password":
      value = value.trim();

      if (value.length < 8) return false;
      if (!/[A-ZİĞÜŞÖÇ]/.test(value)) return false;
      if (!/[a-zığüşöç]/.test(value)) return false;
      if (!/[0-9]/.test(value)) return false;

      return true;

    default:
      return false;
  }
};

export default inputValidations;
